// Capture l'événement beforeinstallprompt le plus tôt possible,
// avant le chargement de React, pour éviter la race condition.
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  // Notifie React si le composant est déjà monté
  window.dispatchEvent(new Event('pwa-prompt-ready'));
});

// Désinscrit tout Service Worker dont le scope n'est pas /oneSignal/
// pour éviter qu'un ancien SW mette en cache index.html.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => {
      if (!reg.scope.includes('/oneSignal/')) {
        reg.unregister();
      }
    });
  });
}
